import InfoSvg from '@assets/images/svg/info.svg';
import React from 'react';
import { View } from 'react-native';

export interface InfoIconProps {
    size?: number;
    color?: string;
}

export function InfoIcon({ size = 24, color = '#333333' }: InfoIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <InfoSvg width={size} height={size} color={color} />
        </View>
    );
}
